import { cross_en } from "@adgm/cross-i18n";

// TODO：后续完善检查当前语言、多语言配置、App远端Merge、updateLocale等功能
// TODO：和Web的i18nUtil命名冲突，暂改为i18nCrossUtil，后续需要在adgm-libs中统一web和app的i18n
const i18nCrossUtil = {
  t: () => {
    return cross_en;
  },
};
export { i18nCrossUtil };
